import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { trackSignupConversion } from '../utils/adsConversion'

const OAuthSuccessPage = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { handleOAuthSuccess } = useAuth()

  useEffect(() => {
    const error = searchParams.get('error')

    if (error) {
      navigate('/login?error=' + error, { replace: true })
      return
    }

    // Cookie was set by backend during OAuth redirect - just verify auth
    const completeOAuth = async () => {
      const result = await handleOAuthSuccess()
      if (result.success) {
        // ?signup=1 zet de backend alleen bij een nieuw aangemaakt account.
        // Awaiten zodat het conversie-event weg is vóór de redirect.
        if (searchParams.get('signup') === '1') {
          await trackSignupConversion(result.user)
        }
        navigate('/dashboard', { replace: true })
      } else {
        navigate('/login?error=oauth_failed', { replace: true })
      }
    }

    completeOAuth()
  }, [searchParams, navigate, handleOAuthSuccess])

  return (
    <div className="min-h-screen bg-white flex flex-col justify-center items-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <div className="w-16 h-16 bg-[#3EB489] rounded-full flex items-center justify-center mx-auto mb-4">
          <div className="w-7 h-7 border-4 border-white border-t-transparent rounded-full animate-spin" role="status" aria-label="Bezig met inloggen"></div>
        </div>
        <h2 className="text-2xl font-bold text-[#0A0F0D] mb-2">
          Inloggen met Google...
        </h2>
        <p className="text-gray-600">
          Een moment geduld terwijl we je account klaarmaken
        </p>
      </div>
    </div>
  )
}

export default OAuthSuccessPage
